import React from 'react';
import PropTypes from 'prop-types';
import i18n from '../../../../i18n';
import defaultIcon from './icon.svg';

import styles from './styles.scss';

const WatchOnSite = ({ logoUrl, onClick }) => {
  return (
    <button
      className={styles.container}
      tabIndex="0"
      title={i18n.t('player.react-player.watch-on-site')}
      onClick={onClick}
    >
      <img src={logoUrl || defaultIcon} height={16} alt="" />
    </button>
  );
};

WatchOnSite.propTypes = {
  logoUrl: PropTypes.string,
  onClick: PropTypes.func,
};

export default WatchOnSite;
